<div class="card" *ngIf="(formApps$ | async)?.length > 0">
  <div class="card-header compact">
    <h1>Applications</h1>
  </div>
  <div>
    <a *ngFor="let app of formApps$ | async" class="app-link text-medium" (click)="openApp(app)">{{ app.name }}</a>
  </div>
</div>
